import UnbindSubcategories from "../symbols/unbindSubcategories";
import { HttpRequestPut } from "../../service";
const bindSubcategoriesAction = () => ({
  type: UnbindSubcategories.UNBIND_SUBCATEGORIES,
});
const bindSubcategoriesSuccessAction = (data: any) => ({
  type: UnbindSubcategories.UNBIND_SUBCATEGORIES_SUCCESS,
  payload: data,
});
const bindSubcategoriesFailureAction = (data: any) => ({
  type: UnbindSubcategories.UNBIND_SUBCATEGORIES_FAILURE,
  payload: data,
});
const clearUnbindSubcategoriesAction = () => ({
  type: UnbindSubcategories.CLEAR_UNBIND_SUBCATEGORIES,
});

export function unbindSubcategories(subcategoryId: string) {
  return (dispatch: any) => {
    dispatch(bindSubcategoriesAction());
    HttpRequestPut(
      `/upc/subcategory/${subcategoryId}/unbind`,
      dispatch,
      bindSubcategoriesSuccessAction,
      bindSubcategoriesFailureAction,
      true,
      {}
    );
  };
}

export function clearUnbindSubcategories() {
  return (dispatch: any) => {
    dispatch(clearUnbindSubcategoriesAction());
  };
}
